import React, { useCallback, useEffect, useState } from 'react';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { useDispatch } from 'react-redux';

import { api, profilePhotouploadDir } from '../../config';
import history from '../../history';

import { getAllThreadItems } from '../../lib/graphql/threads.js'
import useQueryResponse from "../../lib/hooks/useQueryResponse";
import { getBooking } from '../../actions/booking/getBooking.js';
import { readMessageAction } from '../../actions/thread/readMessageAction.js';


import StarRating from '../StarRating/StarRating';
import chatIcon from '../../../public/dashboard/messageIcon.svg';
import phoneIcon from '../../../public/dashboard/phoneIcon.svg';
import defaultIcon from '../../../public/dashboard/defaultIconMenu.svg';
import bt from '../../components/commonStyle.css';
import s from './ProviderDetails.css';


const ProviderDetails = ({ data, isNotMapPage, isAdditionalRequestPopup, noIcons, isMessage, socket }) => {

    const [isSmallDevice, setIsSmallDevice] = useState(false);
    const dispatch = useDispatch()
    let phoneNumber, phoneDialCode
    phoneNumber = data?.partnerDetails?.userData?.phoneNumber, phoneDialCode = data?.partnerDetails?.userData?.phoneDialCode;

    let rating = parseFloat(data?.partnerDetails?.userData?.overallRating)
    const notShowIcons = ['scheduled', 'declined', 'cancelledByUser', 'cancelledByPartner', 'completed', 'expired'].includes(data?.status);

    const handleResizeHandler = useCallback(() => {
        setIsSmallDevice(window.matchMedia('(max-width: 767px)').matches);
    }, []);

    useEffect(() => {
        const isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            handleResizeHandler();
            window.addEventListener('resize', handleResizeHandler);
        }

        return () => {
            window.removeEventListener('resize', handleResizeHandler);
        };
    }, [handleResizeHandler]);

    const handleClick = async () => {
        await dispatch(readMessageAction({ bookingId: data?.id }))
        history.push({
            pathname: `/chat-message/${data?.id}`,
            state: { from: history.location.pathname }
        });
    }

    const { data: threadItems, loading, refetch } = useQueryResponse({
        query: getAllThreadItems,
        variables: {
            offset: 0,
            bookingId: data?.id
        },
    })

    let id = data?.id, variables = {}
    if (socket && data?.id) {
        variables = { bookingId: id, offset: 0 };
        socket.on(`bookingStatusUpdated-${id}`, () => {
            dispatch(getBooking(id))
            refetch(variables)
        })
    }

    let unReadThreadCount = data?.messageData?.unreadThreadCount

    return (
        <div className={cx(isNotMapPage ? s.bookingDetailsNameBox : isAdditionalRequestPopup ? s.additionRequestDetailsBox : s.providerCardDetailsBox)}>
            {
                data?.partnerDetails?.picture ? <div className={cx(isAdditionalRequestPopup ? s.providerCardDetailsAdditionalPopupImgContainer : s.providerCardDetailsImgContainer)}>
                    <img src={`${api.apiEndpoint}${profilePhotouploadDir}medium_${data?.partnerDetails?.picture}`} width="62" height="62" alt="userProfile" />
                </div> : <div className={cx(isAdditionalRequestPopup ? s.providerCardDetailsAdditionalPopupDefaultImgContainer : s.providerCardDetailsDefaultImgContainer)}>
                    <img src={defaultIcon} width="62" height="62" alt="defaultIcon" />
                </div>
            }
            <div className={s.providerCardDetailsInfoContainer}>
                <div className={s.providerCardDetailsHeadingBox}>
                    <h5 className={cx(bt.noMargin, bt.primaryColor, isAdditionalRequestPopup ? [bt.fontWeight600, bt.commonSize16] : [s.providerCardDetailsHeading, bt.fontWeight700])}>{data?.partnerDetails?.firstName}</h5>
                    {!noIcons && !notShowIcons && (data?.bookingType === 1 || data?.bookingType === 2) &&
                        <>
                            {isSmallDevice ? <a href={`tel:${phoneDialCode}${phoneNumber}`} className={bt.viewAllLink}>
                                <span className={bt.displayInlineBlock}>{phoneDialCode}&nbsp;</span>
                                <span className={bt.displayInlineBlock}>{phoneNumber}</span>
                            </a> :
                                <div className={s.phoneNumberLink}>
                                    <span className={bt.displayInlineBlock}>{phoneDialCode}&nbsp;</span>
                                    <span className={bt.displayInlineBlock}>{phoneNumber}</span>
                                </div>
                            }
                        </>
                    }
                    <StarRating value={rating} name={'review'} className={s.providerDetailsRatingContainer} />
                </div>
                {!noIcons && !notShowIcons && (data?.bookingType === 1 || data?.bookingType === 2) && <div className={s.providerCardDetailsIconContainer}>
                    <div className={cx(s.providerCardDetailsIcon, s.providerCardPhoneIconBox)}>
                        <a href={`tel:${phoneDialCode}${phoneNumber}`} className={bt.cursorPointer}>
                            <img src={phoneIcon} alt="phoneIcon" />
                        </a>
                    </div>
                    {!isMessage && <div className={cx(s.providerCardDetailsIcon, bt.cursorPointer)} onClick={handleClick}>
                        <img src={chatIcon} alt="chatIcon" />
                        {unReadThreadCount > 0 && <span className={cx(s.messageIconNotificationDot, "messageIconNotificationDotRtl")} />}
                    </div>}
                </div>}
            </div>
        </div>
    )
}

export default withStyles(bt, s)(ProviderDetails);
